import React, { useCallback, useMemo, useState } from "react"
import { Box } from "@mui/system"
import { Typography, Grid } from "@mui/material"

import ButtonWithIcon from "src/v2/components/Button/Button"
import { ReactComponent as ChatIcon } from "src/v2/assets/icons/chat-icon.svg"
import InputAutoComplete from "src/v2/components/Input/Input-auto-complete"
import { ReactComponent as SearchIcon } from "src/v2/assets/icons/search-icon.svg"
import { ReactComponent as TableBaseIcon } from "src/v2/assets/icons/table-base-icon.svg"

import PropTypes from "prop-types"

import ChatbotInModal from "src/v2/components/Chatbot/chatbot-modal"

const DatalakeHeaderEnterprise = ({
    handleClickFullList,
    options,
    selectedValue,
    inputValue,
    loading,
    error,
    onInputChange,
    onSelectionChange,
    getOptionLabel,
    isOptionEqualToValue,
}) => {

    const [isChatOpen, setIsChatOpen] = useState(false)

    const handleClickHelpButton = useCallback(() => {
        setIsChatOpen(true)
    }, [])

    const handleCloseChat = useCallback(() => {
        setIsChatOpen(false)
    }, [])

    const searchIcon = useMemo(() => <SearchIcon />, [])
    const chatIcon = useMemo(() => <ChatIcon />, [])
    const tableIcon = useMemo(() => <TableBaseIcon />, [])

    return (
        <Grid>
            <Box>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "self-end",
                        backgroundImage:
                            'url("/background/datalake_background_header.png")',
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        height: { xxxs: "224px", md: "199px" },
                        mt: { xxxs: 8, lg: 0 },
                        width: "100%",
                        maxWidth: {
                            xxxs: "calc(100vw - 10px)",
                            lg: "calc(100vw - 223px)",
                        },
                        zIndex: 0,
                    }}
                >
                    <Box
                        display="flex"
                        flexDirection="column"
                        width="100%"
                        gap={3}
                        mt={3}
                        px={3}
                    >
                        <Box
                            display="flex"
                            width="100%"
                            justifyContent="space-between"
                        >
                            <Typography
                                variant={"h2"}
                                color="common.white"
                                mt="auto"
                            >
                                Empresas
                            </Typography>
                            <ButtonWithIcon
                                size="md"
                                icon={chatIcon}
                                onClick={handleClickHelpButton}
                            >
                                AJUDA
                            </ButtonWithIcon>
                        </Box>

                        <Box
                            sx={{
                                display: "flex",
                                gap: 2,
                                alignItems: { xxxs: "self-start", md: "center" },
                                flexDirection: { xxxs: "column", md: "row" },
                                zIndex: 9999,
                            }}
                        >
                            <InputAutoComplete
                                sx={{maxWidth: "608px", width: "100%"}}
                                label="Razão Social ou CNPJ"
                                value={selectedValue}
                                inputValue={inputValue}
                                options={options}
                                loading={loading}
                                error={Boolean(error)}
                                startIcon={searchIcon}
                                onChange={onSelectionChange}
                                onInputChange={onInputChange}
                                getOptionLabel={getOptionLabel}
                                isOptionEqualToValue={isOptionEqualToValue}
                                filterOptions={(availableOptions) => availableOptions}
                                freeSolo
                                autoComplete
                                noOptionsText={() => "Nenhum resultado encontrado"}
                                autoHighlight
                                clearOnEscape
                                disableClearable={false}
                                blurOnSelect={false}
                                clearOnBlur={false}
                                selectOnFocus={false}
                                forcePopupIcon
                            />
                            <ButtonWithIcon
                                icon={tableIcon}
                                onClick={handleClickFullList}
                                size="md"
                                sx={{
                                    width: "auto",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                LISTA COMPLETA
                            </ButtonWithIcon>
                        </Box>
                    </Box>
                </Box>
            </Box>


            <ChatbotInModal
                open={isChatOpen}
                onClose={handleCloseChat}
            />

        </Grid>
    )
}

DatalakeHeaderEnterprise.propTypes = {
    handleClickFullList: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.object),
    selectedValue: PropTypes.object,
    inputValue: PropTypes.string,
    loading: PropTypes.bool,
    error: PropTypes.string,
    onInputChange: PropTypes.func,
    onSelectionChange: PropTypes.func,
    getOptionLabel: PropTypes.func,
    isOptionEqualToValue: PropTypes.func,
}
export default DatalakeHeaderEnterprise
